import { Outlet } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import config from "lib/config"
import { Plus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { MessengerIntegrationsTable } from "./MessengerIntegrationsTable"

export const MessengerConfiguration = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <div className="flex justify-end w-full">
            <a href={config.messengerLoginUrl}>
              <Button>
                <Plus />
                {t("settings.integrations.messenger.table.addIntegration")}
              </Button>
            </a>
          </div>
          <MessengerIntegrationsTable />
        </div>
      </div>
      <Outlet />
    </>
  )
}
